import moment from "moment";
import { numConvert } from "../../../../method";
import { dataDefault } from './data';

export default (data, date) => {
    const month = moment(date).format('M');
    const budgetRev = ['best_rev', 'corporate_rev', 'government_rev', 'packges_rev', 'wholesale_rev', 'commerce_rev', 'discounts_rev', 'business_rev', 'leisure_rev', 'contracts_rev'];

    // 动态赋值month status
    data = data.map((item, index) => {
        let str = '';
        if (index < 42 && index != 40) {
            str = '';
            if (index % 3 == 0) str = `Budget`;
            if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) <= month ? 'Actual' : "Forecast"}`;
            if (index % 3 == 2) str = `Actual Last Year`;
            if (index == 37) str = `Actual`;
        }
        if (index == 46) str = `Act/Fcst`;
        if (index == 45) str = `Budget`;
        if (index == 44) str = `YTD Actual`;
        if (index == 43) str = `Y/E Fcast`;
        if (index == 42) str = `YTD Actual`;
        if (index == 40) str = `Act/Fcst`;
        return { ...item, month_status_name: str, name: dataDefault[index].name }

    });

    //计算每月第一行Rev 和第二行ARR
    data.forEach((item, i) => {
        budgetRev.forEach((name, j) => {
            const RN = name.split('_rev')[0] + '_rn';
            const ARR = name.split('_rev')[0] + '_arr';

            if (i < 42 && i % 3 != 2) {
                data[i][ARR] = item[RN] != 0 ? (item[name] / item[RN]).toFixed(2) : 0;
            }
        });
    });

    // YTD 累加到当前月份之前
    budgetRev.forEach(name => {
        const RN = name.split('_rev')[0] + '_rn';
        const ARR = name.split('_rev')[0] + '_arr';
        data[36][RN] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 0)) {
                a += numConvert(b[RN]);
            }
            return a
        }, 0).toFixed(2);
        data[37][RN] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 1)) {
                a += numConvert(b[RN]);
            }
            return a
        }, 0).toFixed(2);
        data[38][RN] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 2)) {
                a += numConvert(b[RN]);
            }
            return a
        }, 0).toFixed(2);
        data[36][name] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 0)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[37][name] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 1)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[38][name] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 2)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[36][ARR] = data[36][RN] == 0 ? 0 : (data[36][name] / data[36][RN]).toFixed(2);
        data[37][ARR] = data[37][RN] == 0 ? 0 : (data[37][name] / data[37][RN]).toFixed(2);
        data[38][ARR] = data[38][RN] == 0 ? 0 : (data[38][name] / data[38][RN]).toFixed(2);
    });
    ['grand_rms', 'others_rev'].forEach(name => {
        data[36][name] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 0)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[37][name] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 1)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[38][name] = data.reduce((a, b, i) => {
            if (i < 36 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 2)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
    });

    // Total
    const totalListName = ['best_rev', 'corporate_rev', 'government_rev', 'packges_rev', 'wholesale_rev', 'commerce_rev', 'discounts_rev'];
    data.forEach((item, i) => {
        if (i < 39) {
            // TOTAL TRANSIENT
            data[i].total_rn = totalListName.reduce((a, b) => {
                const name = b.split('_rev')[0] + "_rn";
                return (a + numConvert(item[name]))
            }, 0).toFixed(2);
            data[i].total_rev = totalListName.reduce((a, b) => (a + numConvert(item[b])), 0).toFixed(2);
            data[i].total_arr = data[i].total_rn == 0 ? 0 : (data[i].total_rev / data[i].total_rn).toFixed(2);

            // TOTAL GROUPS
            data[i].group_total_rn = ['business_rev', 'leisure_rev'].reduce((a, b) => {
                const name = b.split('_rev')[0] + "_rn";
                return (a + numConvert(item[name]))
            }, 0).toFixed(2);
            data[i].group_total_rev = ['business_rev', 'leisure_rev'].reduce((a, b) => (a + numConvert(item[b])), 0).toFixed(2);
            data[i].group_total_arr = data[i].group_total_rn == 0 ? 0 : (data[i].group_total_rev / data[i].group_total_rn).toFixed(2);

            // GRAND TOTAL
            data[i].grand_rn = ['total_rev', 'group_total_rev', 'contracts_rev'].reduce((a, b) => {
                const name = b.split('_rev')[0] + "_rn";
                return (a + numConvert(item[name]))
            }, 0).toFixed(2);
            data[i].grand_rev = ['total_rev', 'group_total_rev', 'contracts_rev', 'others_rev'].reduce((a, b) => (a + numConvert(item[b])), 0).toFixed(2);
            data[i].grand_arr = data[i].grand_rn == 0 ? 0 : (data[i].grand_rev / data[i].grand_rn).toFixed(2);
            data[i].grand_occ = data[i].grand_rms == 0 ? 0 : (data[i].grand_rn / data[i].grand_rms).toFixed(4);
            data[i].grand_revpar = (data[i].grand_arr * data[i].grand_occ).toFixed(2);
        }
    })

    // Year End
    const listName = ["best_rn", "corporate_rn", "government_rn", "packges_rn", "wholesale_rn", "commerce_rn", "discounts_rn", "total_rn", "business_rn", "leisure_rn", "group_total_rn", "contracts_rn", "grand_rn"];
    const othersName = ['others_rev', 'grand_rms'];
    [...listName].forEach(name => {
        const ARR = name.split('_rn')[0] + "_arr";
        const REV = name.split('_rn')[0] + "_rev";
        [name, REV].forEach(newName => {
            data[39][newName] = data.reduce((a, b, i) => {
                if (i < 36 && i % 3 == 0) {
                    a += numConvert(b[newName]);
                }
                return a
            }, 0).toFixed(2);
            data[40][newName] = data.reduce((a, b, i) => {
                if (i < 36 && i % 3 == 1) {
                    a += numConvert(b[newName]);
                }
                return a
            }, 0).toFixed(2);
            data[41][newName] = data.reduce((a, b, i) => {
                if (i < 36 && i % 3 == 2) {
                    a += numConvert(b[newName]);
                }
                return a
            }, 0).toFixed(2);
        });
        [39, 40, 41].forEach(index => {
            data[index][ARR] = data[index][name] == 0 ? 0 : (data[index][REV] / data[index][name]).toFixed(2)
        });
    });
    [...othersName].forEach(name => {
        data[39][name] = data.reduce((a, b, i) => {
            if (i < 36 && i % 3 == 0) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[40][name] = data.reduce((a, b, i) => {
            if (i < 36 && i % 3 == 1) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[41][name] = data.reduce((a, b, i) => {
            if (i < 36 && i % 3 == 2) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
    });

    // 计算occ % 
    data.forEach((item, i) => {
        if (i < 41 && i >= 39 && i % 3 != 2) {
            data[i].grand_arr = data[i].grand_rn == 0 ? 0 : (data[i].grand_rev / data[i].grand_rn).toFixed(2);
            data[i].grand_occ = data[i].grand_rms == 0 ? 0 : (data[i].grand_rn / data[i].grand_rms).toFixed(4);
            data[i].grand_revpar = (data[i].grand_arr * data[i].grand_occ).toFixed(2);
        }
    });

    // % to Budget --- Year End Mix %
    const allListName = ["best_rn", "best_arr", "best_rev", "corporate_rn", "corporate_arr", "corporate_rev", "government_rn", "government_arr", "government_rev", "packges_rn", "packges_arr", "packges_rev", "wholesale_rn", "wholesale_arr", "wholesale_rev", "commerce_rn", "commerce_arr", "commerce_rev", "discounts_rn", "discounts_arr", "discounts_rev", "total_rn", "total_arr", "total_rev", "business_rn", "business_arr", "business_rev", "leisure_rn", "leisure_arr", "leisure_rev", "group_total_rn", "group_total_arr", "group_total_rev", "contracts_rn", "contracts_arr", "contracts_rev", "others_rev", "grand_rn", "grand_arr", "grand_rev", "grand_occ", "grand_revpar", "grand_rms"];
    allListName.forEach(name => {
        data[42][name] = data[36][name] == 0 ? 0 : ((data[37][name] - data[36][name]) / data[36][name]).toFixed(4);
        data[43][name] = data[39][name] == 0 ? 0 : ((data[40][name] - data[39][name]) / data[39][name]).toFixed(4);
        data[44][name] = data[38][name] == 0 ? 0 : ((data[37][name] - data[38][name]) / data[38][name]).toFixed(4);
        // if (!name.includes('grand_')) {
        if (name.includes("_rn")) {
            data[45][name] = data[39]['grand_rn'] == 0 ? 0 : (data[39][name] / data[39]['grand_rn']).toFixed(4);
            data[46][name] = data[40]['grand_rn'] == 0 ? 0 : (data[40][name] / data[40]['grand_rn']).toFixed(4);
        }
        if (name.includes("_rev")) {
            data[45][name] = data[39]['grand_rev'] == 0 ? 0 : (data[39][name] / data[39]['grand_rev']).toFixed(4);
            data[46][name] = data[40]['grand_rev'] == 0 ? 0 : (data[40][name] / data[40]['grand_rev']).toFixed(4);
        }
        // }
    });

    return data
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/compute.js